import DOMPurify from 'dompurify'

export function sanitizeHtml(dirtyHtml?: string) {
	if (!dirtyHtml) {
		return ''
	}

	return DOMPurify.sanitize(dirtyHtml, {
		ALLOW_DATA_ATTR: false,
		ALLOW_ARIA_ATTR: false,
		FORBID_ATTR: ['class', 'style', 'dir', 'start', 'role', 'data'],
		FORBID_TAGS: ['hr', 'br'],
	})
}
